import React, { useState, useEffect, ReactElement } from 'react';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Menu, MenuItem, Theme, TableRow, Tooltip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { styled } from '@mui/material/styles';
import { Dictionary } from '../../../Common/CommonModel';
import { ClientSecretMenuItems } from '../Model/ClientSecretesModel';
import RefreshSecretComponent from './RefreshSecretComponent';
import MuiTableCell from '@mui/material/TableCell';
import AddEditGroup from './AddEditGoupComponent';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles()((theme: Theme) => ({
  menu: {
    padding: 0,
  },
  button: {
    margin: theme.spacing(1),
    width: 200,
  },
  tableRow: {
    height: 'fit-content',
  },
}));

const TableCell = styled(MuiTableCell)({
  borderBottom: 'none',
  whiteSpace: 'nowrap',
  padding: '2px',
});

export default function ClientsSecreteMenu(
  props: Readonly<{
    customerId: string;
    clientId: string;
  }>,
) {
  const { classes } = useStyles();
  const { t } = useTranslation('clientsecret');
  const [openRefreshPage, setOpenRefreshPage] = useState(false);
  const [openGoupPage, setOpenGoupPage] = useState(false);
  const [anchor, setAnchor] = useState<HTMLButtonElement | null>(null);
  const [menuState, setMenuState] = useState(false);

  const handleRefresh = () => {
    closeClientSecretMenu();
    setOpenRefreshPage(true);
  };
  const handleAddGroups = () => {
    closeClientSecretMenu();
    setOpenGoupPage(true);
  };
  const menuItems: ClientSecretMenuItems[] = [
    {
      id: 'Refresh',
      label: 'Refresh Secret',
      validationFunc: 'Refresh',
      handleFunc: handleRefresh,
    },
    {
      id: 'AddGroups',
      label: 'Add Groups',
      validationFunc: 'AddGroups',
      handleFunc: handleAddGroups,
    },
  ];

  const showRefreshPage = (open: boolean): ReactElement | null => {
    if (open) {
      return (
        <RefreshSecretComponent
          setOpen={setOpenRefreshPage}
          clientId={props.clientId}
          customerId={props.customerId}
        />
      );
    }
    return null;
  };

  const showGroup = (open: boolean): ReactElement | null => {
    if (open) {
      return (
        <AddEditGroup
          setOpen={setOpenGoupPage}
          clientId={props.clientId}
          customerId={props.customerId}
        />
      );
    }
    return null;
  };

  useEffect(() => {}, []);
  const closeClientSecretMenu = () => {
    setMenuState(false);
    setAnchor(null);
  };

  const openClientSecretMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuState(true);
    setAnchor(event.currentTarget);
  };

  function executeValidationMethod(type: string) {
    let fn;
    const validations: Dictionary<() => boolean> = {};
    validations['Refresh'] = () => true;

    if (validations[type]) {
      fn = validations[type];
    } else {
      fn = validations['default'];
    }
    return fn();
  }

  return (
    <div>
      <Tooltip title={t('clientsecret.tooltip.menu')}>
        <IconButton
          aria-label="More"
          aria-owns="long-menu"
          aria-haspopup="true"
          onClick={openClientSecretMenu}
          className={classes.menu}
          size="large"
        >
          <MoreVertIcon />
        </IconButton>
      </Tooltip>
      {menuItems.some((menu) =>
        executeValidationMethod(menu.validationFunc),
      ) && (
        <Menu
          id="long-menu"
          anchorEl={anchor}
          open={menuState}
          onClose={closeClientSecretMenu}
        >
          {menuItems.map((menu) => (
            <MenuItem
              onClick={menu.handleFunc}
              id={props.clientId}
              value={menu.label}
              key={menu.id}
            >
              <TableRow className={classes.tableRow}>
                <TableCell> {menu.label}</TableCell>
              </TableRow>
            </MenuItem>
          ))}
        </Menu>
      )}
      {showRefreshPage(openRefreshPage)}
      {showGroup(openGoupPage)}
    </div>
  );
}
